<transition name="expand" @enter="enter" @after-enter="afterEnter" @leave="leave"><slot></slot></transition>